import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Remove any injected "Made with Emergent" badge and keep watching for re-insertion.
(function removeBrandingBadge() {
  const strip = () => {
    document
      .querySelectorAll(
        '#emergent-badge, a[href*="emergent.sh"], a[href*="emergent-badge"]'
      )
      .forEach((el) => el.remove());
  };
  strip();
  if (typeof document !== "undefined") {
    document.addEventListener("DOMContentLoaded", strip);
    window.addEventListener("load", strip);
    try {
      new MutationObserver(strip).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    } catch (_) {
      /* noop */
    }
    // Belt-and-braces: for a short period after load, poll aggressively.
    let count = 0;
    const iv = setInterval(() => {
      strip();
      if (++count > 40) clearInterval(iv);
    }, 250);
  }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
